import React from "react";
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs";
import DropAMessage from "./DropAMessage";
import ContactForm from "./ContactForm";
import Location from "./Location";
import "./Contact.css";

const Contact = () => {
  return (
    <div>
      <Breadcrumbs title="Contact us" />
      <div className="container py-16">
        <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-6 gap-2 justify-between">
          <DropAMessage/>
          <ContactForm/>
        </div>
        <Location/>
      </div>
    </div>
  );
};

export default Contact;
